export default __webpack_public_path__ + "static/media/dulces_front.16747af0.jpg";